import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-nav-ribbon',
  templateUrl: './nav-ribbon.component.html',
  styleUrls: ['./nav-ribbon.component.scss']
})
export class NavRibbonComponent implements OnInit {

  @Input() navRibbonCards;
  @Input() notifications;
  @Output() clickedIndex: EventEmitter<any> = new EventEmitter<any>();

  @Input() activeIndex;

  imagePath = '../../../assets/';

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToRoute(index) {
    this.activeIndex = index;
    this.clickedIndex.emit(index);
    if (this.navRibbonCards[index].openNewTab) {
      window.open(this.navRibbonCards[index].url, "_self");
    } else {
      this.router.navigateByUrl(this.navRibbonCards[index].url);
    }
  }

}
